import { useEffect, useState } from "react";
import { apiJSON } from "./api";
import { useAuth } from "./auth";

type State<T> = { data: T | null; loading: boolean; error: string | null };

export function useFetch<T>(path: string): State<T> & { refresh: () => void } {
  const { session } = useAuth();
  const [state, setState] = useState<State<T>>({ data: null, loading: true, error: null });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    apiJSON<T>(path, { token: session?.token })
      .then((data) => {
        if (!cancelled) setState({ data, loading: false, error: null });
      })
      .catch((err) => {
        if (!cancelled)
          setState({ data: null, loading: false, error: String(err?.message ?? err) });
      });
    return () => {
      cancelled = true;
    };
  }, [path, session?.token, tick]);

  return { ...state, refresh: () => setTick((n) => n + 1) };
}
